import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const RegionSlice =  createSlice({
    name:"Region",
    initialState:{
        name:""
    },
    reducers:{
        SetRegion(state, action: PayloadAction<string>){
            state.name = action.payload
        }
    }
});

export const { SetRegion } = RegionSlice.actions
export default RegionSlice.reducer